/* unplugin-vue-components disabled */import { render } from "./ImgAddLogo.vue?vue&type=template&id=d0ddbe6e&scoped=true"
import script from "./ImgAddLogo.vue?vue&type=script&lang=js"
export * from "./ImgAddLogo.vue?vue&type=script&lang=js"

import "./ImgAddLogo.vue?vue&type=style&index=0&id=d0ddbe6e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0ddbe6e"]])

export default __exports__